import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "@globalConfig";
import { canonicalize } from "@/utils/common";
import { checkTestFlag } from "@/common/config/websiteConfig";
import { ucWords } from "@/utils/stringHelpers";
export var _objectToHash = function _objectToHash(hash) {
  var hashParams = [];
  for (var _i = 0, _Object$entries = Object.entries(hash); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    hashParams.push("".concat(key, "=").concat(value));
  }
  return hashParams.length > 0 ? "#" + hashParams.join("&") : "";
};
//Create Internal Link with params
export var _internal_create_link = function _internal_create_link() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var lang = arguments.length > 2 ? arguments[2] : undefined;
  var hash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var langParam = lang !== "ar" ? "/en" : "";
  var urlParams = [];
  for (var _i2 = 0, _Object$entries2 = Object.entries(params); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      key = _Object$entries2$_i[0],
      value = _Object$entries2$_i[1];
    if (value === null || value === undefined) continue;
    urlParams.push("".concat(key, "=").concat(value));
  }
  if (path.includes('?')) {
    var pathArray = path.split('?');
    path = pathArray[0];
    urlParams.push(pathArray[1]);
  }
  path = path.replace('/en/', '/').replace(/^\/en/, '/').replace(/\/$/, '');
  return "".concat(langParam).concat(path ? path : "/").concat(urlParams.length > 0 ? "?" + urlParams.join("&") : "").concat(_objectToHash(hash));
};
var useHelpers = function useHelpers() {
  var lang = useLang();
  var navigate = useNavigate();
  var lang2 = lang === "ar" ? "en" : "ar";
  var createUrl = function createUrl(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!url) return "";
    if (url.startsWith('http')) {
      var newUrl = new URL(url);
      return newUrl.pathname + newUrl.search;
    }
    var uri = _internal_create_link(url, params, lang, hash);
    if (lang === 'en' && uri.startsWith('/en')) {
      uri = uri.replace('/en/en', '/en');
    }
    return uri;
  };
  var createUrlAbsolute = function createUrlAbsolute(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return serverUrl + createUrl(url, params);
  };
  var navigateTo = function navigateTo(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return navigate(createUrl(url, params));
  };
  var navigateBack = function navigateBack() {
    navigate(-1);
  };
  var navigateToHard = function navigateToHard(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (checkTestFlag('TEST_INTERRUPT_NAVIGATION')) {
      if (confirm("[TEST_INTERRUPT_NAVIGATION] continue to : " + createUrl(url, params))) {
        window.location.href = createUrl(url, params);
      }
      return;
    }
    window.location.href = createUrl(url, params);
  };

  /**
   * The same URL in the other language — the language switcher's target.
   *
   * `canonicalize` keeps only an SEO allowlist of query params
   * (`sol`, `page`, `sort`, `postId`, `financestep`, `post_id`) and deletes
   * the rest, which is right for a canonical tag but wrong for a switcher on
   * a page whose state lives in the query: `/checkout/create-araboon`
   * reads `order_id`, and switching language was dropping it and stranding
   * the user on a page with no order. `/filters` already opted out so search
   * keeps its facets; `keepQuery` is the general form of that escape, for
   * callers that need the URL carried across intact.
   */
  var createUrl2 = function createUrl2(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var keepQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var link = _internal_create_link(url, params, lang2);
    if (keepQuery || url.includes('/filters')) return link;
    return canonicalize(link);
  };
  var getCurrentUrl = function getCurrentUrl() {
    if (__IS_SSR__) return "";
    return window.location.href;
  };
  var label = function label(object) {
    if (!object) return '';
    var theLabel = "";
    if (lang === 'ar') {
      theLabel = object.name_ara || object.name || (object === null || object === void 0 ? void 0 : object.name_ar);
    } else {
      theLabel = object.name_eng || object.name_en || object.name;
    }
    return ucWords(theLabel);
  };
  return {
    label: label,
    createUrl: createUrl,
    createUrlAbsolute: createUrlAbsolute,
    createUrl2: createUrl2,
    navigateTo: navigateTo,
    navigateBack: navigateBack,
    navigateToHard: navigateToHard,
    getCurrentUrl: getCurrentUrl
  };
};
export default useHelpers;